.mainPaper {
	margin-top: 50px !important;
}

.maxWidth {
	max-width: 1200px !important;
}
